import { createContext } from 'react';

const AmpContext = createContext<boolean>(false);
export default AmpContext;
